import makeInitialState from 'client/makeInitialState';

export default async function enableAllListings({ state }) {
  const listingsState = state.get(['listings']);
  const initialState = makeInitialState();

  state.set('listings', {
    ...initialState.listings,
    records: listingsState.records,
    viewMoreIndex: listingsState.total,
    totalListingsCount: listingsState.totalListingsCount,
    enableAllListings: true,
  });

  state.commit();
}
